import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";
import { useCommonTranslation } from "@/services/culture/common.translations";
import { useIdentityAndAccessTranslation } from "@/services/culture/identity-and-access.translations";
import { useNavigate } from "@tanstack/react-router";
import { Button, Icon, Input, Modal, tokens, Typography, useCurrentDialog, useToast } from "@vintecc/components";
import { faWebhook } from "@vintecc/pro-light-svg-icons";
import { faArrowRight, faCopy } from "@vintecc/pro-solid-svg-icons";
import { FC } from "react";

interface ApiTokenModalProps {
  token: string;
}

const ApiTokenModal: FC<ApiTokenModalProps> = ({ token }) => {
  const { t: translateI } = useIdentityAndAccessTranslation();
  const { t: translateC } = useCommonTranslation();
  const { openToast } = useToast();
  const { close } = useCurrentDialog();
  const navigate = useNavigate();
  const { copyToClipboard } = useCopyToClipboard();

  return (
    <Modal className="p-8 w-80" testId="api-token-modal">
      <div className="flex flex-col justify-center items-center gap-4 mb-8">
        <Icon icon={faWebhook} size="xl" />
        <div className="flex flex-col gap-2 items-center">
          <Typography variant="h3">{translateI("apiTokens.secret.title")}</Typography>
          <Typography variant="p" color={tokens.theme.error.color}>
            {translateI("apiTokens.secret.onceWarning")}
          </Typography>
        </div>
        <Input className="w-full" type="password" value={token} readOnly label={translateI("apiTokens.secret.title")} />
      </div>
      <div className="flex flex-col gap-4">
        <Button
          startIcon={<Icon icon={faCopy} />}
          onClick={() => {
            copyToClipboard(token);
            close();
            navigate({ to: "/identity-and-access/api-tokens" });
          }}
        >
          {translateC("common.copyToClipboard")}
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            close();
            openToast({ message: translateI("apiTokens.secret.createdTokenToast"), intent: "success" });
            navigate({ to: "/identity-and-access/api-tokens" });
          }}
          endIcon={<Icon icon={faArrowRight} />}
        >
          {translateC("common.continue")}
        </Button>
      </div>
    </Modal>
  );
};

export default ApiTokenModal;
